import { useState } from "react"
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    RedditIcon,
    RedditShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
    XIcon,
} from "react-share"

// Sized and shaped like the react-share icons beside it.
const COPY_ICON_STYLE = {
    width: 32,
    height: 32,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#ffffff",
    fontSize: 18,
}

export default function ShareBar({ title, url, summary }) {
    const [copied, setCopied] = useState(false)

    async function copyLink() {
        try {
            await navigator.clipboard.writeText(url)
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        } catch (error) {
            console.error("Copy link failed:", error)
        }
    }

    return (
        <div className="pt-4 pb-4">
            <div className="d-flex flex-wrap align-items-center justify-content-center gap-2">
                <button
                    type="button"
                    className="border-0 bg-transparent p-0"
                    onClick={copyLink}
                    title={copied ? "Link copied" : "Copy link"}
                    aria-label={copied ? "Link copied" : "Copy link"}
                >
                    <span
                        style={{
                            ...COPY_ICON_STYLE,
                            backgroundColor: copied ? "#198754" : "#6c757d",
                        }}
                    >
                        <i
                            className={`bi ${copied ? "bi-check2" : "bi-link-45deg"}`}
                        ></i>
                    </span>
                </button>
                <FacebookShareButton
                    url={url}
                    hashtag="chaperon"
                    htmlTitle="Share on Facebook"
                    aria-label="Share on Facebook"
                >
                    <FacebookIcon size={32} round />
                </FacebookShareButton>
                <TwitterShareButton
                    title={title}
                    url={url}
                    hashtag="chaperon"
                    htmlTitle="Share on X"
                    aria-label="Share on X"
                >
                    <XIcon size={32} round />
                </TwitterShareButton>
                <WhatsappShareButton
                    title={title}
                    url={url}
                    htmlTitle="Share on WhatsApp"
                    aria-label="Share on WhatsApp"
                >
                    <WhatsappIcon size={32} round />
                </WhatsappShareButton>
                <TelegramShareButton
                    title={title}
                    url={url}
                    htmlTitle="Share on Telegram"
                    aria-label="Share on Telegram"
                >
                    <TelegramIcon size={32} round />
                </TelegramShareButton>
                <FacebookMessengerShareButton
                    title={title}
                    url={url}
                    htmlTitle="Share on Messenger"
                    aria-label="Share on Messenger"
                >
                    <FacebookMessengerIcon size={32} round />
                </FacebookMessengerShareButton>
                <LinkedinShareButton
                    title={title}
                    url={url}
                    summary={summary}
                    source="Chaperon"
                    htmlTitle="Share on LinkedIn"
                    aria-label="Share on LinkedIn"
                >
                    <LinkedinIcon size={32} round />
                </LinkedinShareButton>
                <RedditShareButton
                    title={title}
                    url={url}
                    htmlTitle="Share on Reddit"
                    aria-label="Share on Reddit"
                >
                    <RedditIcon size={32} round />
                </RedditShareButton>
                <EmailShareButton
                    subject={title}
                    url={url}
                    htmlTitle="Share by email"
                    aria-label="Share by email"
                >
                    <EmailIcon size={32} round />
                </EmailShareButton>
            </div>
        </div>
    )
}
